import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Trash2, Plus, Eye, EyeOff } from "lucide-react";
import { api } from "@/lib/api";

const input = "w-full rounded-lg border border-[#2C2C2C]/20 bg-white px-3 py-2 text-sm outline-none focus:border-[#C9A84C]";
const EMPTY = { name: "", description: "", published: false, order: 0 };

export default function AdminReferences() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);

  const load = useCallback(() => { api.get("/references", { params: { include_hidden: true } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    if (!form.name.trim()) { toast.error("Nom requis"); return; }
    try { await api.post("/references", { ...form, order: items.length }); setForm(EMPTY); toast.success("Référence ajoutée"); load(); }
    catch { toast.error("Échec"); }
  };
  const update = async (it, patch) => { try { await api.put(`/references/${it.id}`, { ...it, ...patch }); load(); } catch { toast.error("Échec"); } };
  const remove = async (id) => { if (!window.confirm("Supprimer ?")) return; try { await api.delete(`/references/${id}`); load(); } catch { toast.error("Échec"); } };

  return (
    <div data-testid="admin-references">
      <h1 className="font-serif text-3xl text-[#2C2C2C]">Références clients — « Ils nous ont fait confiance »</h1>
      <p className="mt-1 text-sm text-[#2C2C2C]/60">Ne publiez une référence que si la relation est vérifiée et son usage autorisé. Par défaut, une nouvelle référence est masquée.</p>

      <div className="mt-6 rounded-xl border border-[#2C2C2C]/10 bg-white p-6">
        <input className={input} placeholder="Nom de la référence (ex. une entreprise, une institution)" data-testid="reference-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <input className={`${input} mt-3`} placeholder="Description / contexte (optionnel)" data-testid="reference-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
        <button onClick={add} data-testid="reference-add" className="mt-4 flex items-center gap-2 rounded-lg bg-[#2C2C2C] px-5 py-2.5 text-sm text-white hover:bg-[#C9A84C] hover:text-[#2C2C2C]"><Plus size={15} /> Ajouter (masquée par défaut)</button>
      </div>

      <div className="mt-6 space-y-3">
        {items.length === 0 && <p className="text-[#2C2C2C]/50" data-testid="references-empty">Aucune référence.</p>}
        {items.map((r) => (
          <div key={r.id} className="flex items-center justify-between gap-4 rounded-xl border border-[#2C2C2C]/10 bg-white p-4" data-testid={`reference-item-${r.id}`}>
            <div>
              <p className="font-medium text-[#2C2C2C]">{r.name} {r.published ? <span className="ml-2 text-xs text-green-700">publiée</span> : <span className="ml-2 text-xs text-[#2C2C2C]/40">masquée</span>}</p>
              {r.description && <p className="text-sm text-[#2C2C2C]/60">{r.description}</p>}
            </div>
            <div className="flex shrink-0 gap-2">
              <button onClick={() => update(r, { published: !r.published })} className="text-[#2C2C2C]/70">{r.published ? <Eye size={16} /> : <EyeOff size={16} />}</button>
              <button onClick={() => remove(r.id)} className="text-red-600"><Trash2 size={16} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
